
          import "Toast.styles_uq0mv1.linaria.css";
          import { styled } from "@linaria/react";
import { css } from "@linaria/core";
const slideOnAnimationBottom = "s11o1tqz";
const slideOnAnimationTop = "s1228oik";
const slideOnAnimationBottomCenter = "s51pc4s";
const slideOnAnimationTopCenter = "s2xdzfw";
const Styles = /*#__PURE__*/styled("div")({
  name: "Styles",
  class: "sjufmnk"
});
export { Styles, slideOnAnimationBottom, slideOnAnimationTop, slideOnAnimationBottomCenter, slideOnAnimationTopCenter };
          